module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/bottom-hero-61c5f73c57896b16.png"+" 2304w",
        images: [{path: __webpack_public_path__ + "assets/images/bottom-hero-61c5f73c57896b16.png",width: 2304,height: 2304}],
        src: __webpack_public_path__ + "assets/images/bottom-hero-61c5f73c57896b16.png",
        toString: function(){return __webpack_public_path__ + "assets/images/bottom-hero-61c5f73c57896b16.png"},
        
        width: 2304,
        height: 2304
      }